module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Medium_FI.ab37df3c.png";